import { useAui, useAuiState } from "@assistant-ui/react";
import { useEffect, useRef } from "react";
import { getDraft, saveDraft } from "@/lib/drafts";

/**
 * Keeps the composer's text per chat (ADMIN-212): saved as you type, put back when you return to
 * the chat, and forgotten once it's sent. Only saved chats keep a draft (lib/drafts.ts).
 */
export function useComposerDraft() {
  const aui = useAui();
  const threadId = useAuiState(
    (s: { threadListItem: { remoteId: string | undefined } }) => s.threadListItem.remoteId,
  );
  const text = useAuiState((s) => s.composer.text);
  const restoredFor = useRef<string | undefined>(undefined);

  // On arriving in a chat, put its draft back (unless something is already being typed).
  useEffect(() => {
    if (!threadId || restoredFor.current === threadId) return;
    restoredFor.current = threadId;
    const draft = getDraft(threadId);
    if (draft && !aui.composer().getState().text) aui.composer().setText(draft);
  }, [aui, threadId]);

  // Save as you type. A new chat gets its id when it's sent, after the text has gone.
  useEffect(() => {
    if (!threadId || restoredFor.current !== threadId) return;
    saveDraft(threadId, text);
  }, [threadId, text]);
}
